import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  message,
  Radio,
  Cascader,
  Space,
} from "antd";
import { LeftOutlined } from "@ant-design/icons";
import moment from "moment";

import "./qsetjddetails.scss";
import useJDStore from "../../store/jd.store";
import useMembersStore from "../../store/members.store";
import { ROLE_TYPE_OPTIONS, SUPPORTED_LOCATION, WORK_OPTIONS } from "../../helper/categoryconstants";

function QSETJdDetails() {
  const [formKey, setFormKey] = useState(1);
  const [isRequired, setIsRequired] = useState(true);
  const [jdUpdated, setIsJDUpdated] = useState(false);
  const { Option } = Select;
  const navigate = useNavigate();
  const { value } = useParams();
  const {
    createJd,
    updateJd,
    selectedJD,
    clearJD,
    refreshJDFlag,
    resetJDRefreshFlag,
    getJdByID,
  } = useJDStore();
  const {
    getVendors,
    vendors,
    getTeamMembers,
    teamMembers,
    assignedTeamMembers,
    getAssignedMembers,
  } = useMembersStore();
  const { clients } = useMembersStore();
  const { TextArea } = Input;

  const bStream = [
    { value: "any", label: "Any" },
    { value: "it", label: "IT" },
    { value: "computers", label: "Computers" },
    { value: "electronics", label: "Electronics" },
    { value: "electrical", label: "Electrical" },
    { value: "civil", label: "Civil" },
    { value: "mechanical", label: "Mechanical" },
    { value: "metallurgy", label: "Metallurgy" },
  ];

  const bDegrees = [
    { value: "btech", label: "BE/BTech", children: bStream },
    { value: "bca", label: "BCA" },
    { value: "bcom", label: "BCom" },
    { value: "bpharma", label: "Bpharma" },
    { value: "bsc", label: "BSc" },
    { value: "bs", label: "BS" },
    { value: "any", label: "Any" },
  ];

  const mDegrees = [
    { value: "mtech", label: "ME/MTech", children: bStream },
    { value: "mca", label: "MCA" },
    { value: "mcom", label: "MCom" },
    { value: "mpharma", label: "Mpharma" },
    { value: "msc", label: "MSc" },
    { value: "ms", label: "MS" },
    { value: "any", label: "Any" },
  ];

  const medicalDegrees = [
    { value: "mbbs", label: "MBBS", children: bStream },
    { value: "md", label: "MS/MD" },
    { value: "any", label: "Any" },
  ];

  const businessDegrees = [
    { value: "mba", label: "MBA", children: bStream },
    { value: "bba", label: "BBA" },
    { value: "any", label: "Any" },
  ];
  const educationList = [
    { value: "Bachelors", label: "Bachelors", children: bDegrees },
    { value: "Masters", label: "Masters", children: mDegrees },
    { value: "Medical", label: "Medical", children: medicalDegrees },
    { value: "Business", label: "Business", children: businessDegrees },
    { value: "Diploma", label: "Diploma" },
    { value: "Phd", label: "Phd" },
  ];

  const [jdValues, setJdValues] = useState({});
  const [reqType, setReqType] = useState("customer_project");
  const [ctcType, setCTCType] = useState("normal");
  const [formMargin, setMargin] = useState(0);
  const [formFinalBillRate, setFinalBillRate] = useState(0);
  const [formMaxDerivedCTC, setMaxDerivedCTC] = useState(0);
  const [formClientName, setformClientName] = useState("");
  const [formTaName, setformTaName] = useState("");

  const getValueForCascaderClient = (client, TA) => {
    const str = client + "," + TA;
    const arr = str.split(",");
    return arr;
  };
  const initJDParams = () => {
    var jdValuesTmp;
    if (value !== undefined) {
      //console.log("Selected JD", selectedJD)
      jdValuesTmp = {
        bu_name: selectedJD?.JDProject.BuName,
        proj_name: selectedJD?.JDProject.ProjectName,
        job_category: selectedJD?.JDDetails.JobCategory,
        job_permission: selectedJD?.JDDetails.JobPermission,
        title: selectedJD?.JDDetails.Title,
        req_type: selectedJD?.JDProject.ReqType,
        ctc_type: selectedJD?.JDProject.CTCType,
        client_name: getValueForCascaderClient(
          selectedJD?.JDClient.ClientName,
          selectedJD?.JDClient.TaName
        ),
        ta_name: selectedJD?.JDClient.TaName,
        end_client_name: selectedJD?.JDClient.EndClient,
        client_job_type: selectedJD?.JDClient.ClientJobType,
        job_type: selectedJD?.JDDetails.JobType,
        job_time: selectedJD?.JDDetails.JobTime,
        designation: selectedJD?.JDDetails.Designation,
        roles_and_responsibility: selectedJD?.JDRequired.RoleDetails,
        roletype: selectedJD?.JDRequired.RoleType,
        role: selectedJD?.JDRequired.Role,
        skills: selectedJD?.JDRequired.Skills,
        keywords: selectedJD?.JDRequired.Keywords,
        soft_skills: selectedJD?.soft_skills,
        education: selectedJD?.JDRequired.Education,
        finalbillrate: selectedJD?.JDProject.FinalBillRate,
        margin: selectedJD?.JDProject.Margin,
        maxctclpm: selectedJD?.JDProject.MaxCTCLPM,
        min_ctc: selectedJD?.JDProject.MinCtc,
        max_ctc: selectedJD?.JDProject.MaxCtc,
        creation_date: selectedJD?.creation_date,
        priority: selectedJD?.JDOther.Priority,
        number_of_positions: selectedJD?.JDProject.NumPositions,
        valid_until: moment(selectedJD?.valid_until),
        work_location: selectedJD?.JDRequired.WorkLocation,
        work_mode: selectedJD?.JDRequired.WorkMode,
        notice_period: selectedJD?.JDRequired.NoticePeriod,
        min_exp: selectedJD?.JDRequired.MinExperience,
        max_exp: selectedJD?.JDRequired.MaxExperience,
        hm_name: selectedJD?.HmName,
        hm_email: selectedJD?.HmEmail,
        hm_number: selectedJD?.HmNumber,
      };
      //console.log("JD Tmp", jdValuesTmp)
      setReqType(jdValuesTmp?.req_type);
      setCTCType(jdValuesTmp?.ctc_type);
      setMargin(jdValuesTmp?.margin);
      setFinalBillRate(jdValuesTmp?.finalbillrate);
      setMaxDerivedCTC(jdValuesTmp?.maxctclpm);
      setformClientName(selectedJD?.JDClient.ClientName);
      setformTaName(selectedJD?.JDClient.TaName);
      setJdValues(jdValuesTmp);
    }
  };

  //selected jd from table
  useEffect(() => {
    //console.log("Calling Refresh UseEffect", value,refreshJDFlag )
    if (value !== undefined && refreshJDFlag) {
      resetJDRefreshFlag();
      initJDParams();
      //console.log("Select JD", value, selectedJD);
    }
    setFormKey((prevKey) => prevKey + 1);
    //console.log("Exit Flag Based useEffet")
  }, [refreshJDFlag]);

  //for createjd and local view changes
  useEffect(() => {
    //console.log("Calling Init UseEffect", value,refreshJDFlag )
    if (value !== undefined && !refreshJDFlag) {
      const fetchData = async (value) => {
        try {
          getJdByID(value);
          getVendors();
          getTeamMembers();
          getAssignedMembers(value);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData(value);
    } else {
      //console.log("clearing JD and selected mode",selectedJD);

      clearJD();
      setJdValues({});
    }
  }, []);

  //selected jd from table
  useEffect(() => {
    console.log("JD update ", value, refreshJDFlag);
    if (value !== undefined && !refreshJDFlag && jdUpdated) {
      const fetchData = async (value) => {
        try {
          getJdByID(value);
          setIsJDUpdated(false);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };
      fetchData(value);
    } else {
      setIsJDUpdated(false);
    }
    //console.log("Exit Flag Based useEffet")
  }, [jdUpdated]);

  //dont render until we have updated result
  if (value !== undefined && refreshJDFlag) return;

  var clientTADB = clients?.map((client, idx) => {
    var tL = client?.ClientTAList;
    //get the TA list for each
    var taListDB = tL?.map((ta, idx) => {
      return {
        value: ta?.TAName,
        label: ta?.TAName,
      };
    });
    return {
      value: client?.ClientName,
      label: client?.ClientName,
      children: taListDB,
    };
  });
  const handleClientandTA = (val) => {
    console.log("Value", val);
    //console.log('Client and TA Option Cient DB Array', clientTADB);
    setformClientName(val[0]);
    setformTaName(val[1]);
    //jdValues.client_name = val[0]
    //jdValues.ta_name = val[1]
    //console.log("Selected Client and TA",jdValues.client_name, jdValues.ta_name);
  };
  const getMaxCTCLpm = (rate, margin) => {
    //console.log('Rate, margin', rate,margin);
    var maxCTCLPM, marginFraction;
    marginFraction = margin / 100;
    maxCTCLPM = rate / (1 + marginFraction);
    maxCTCLPM = maxCTCLPM.toFixed(4);
    return maxCTCLPM;
  };

  const handleMargin = (e) => {
    setMargin(e.target.value);
    setMaxDerivedCTC(getMaxCTCLpm(formFinalBillRate, e.target.value));
  };
  const handleFinalBillRate = (e) => {
    setFinalBillRate(e.target.value);
    setMaxDerivedCTC(getMaxCTCLpm(e.target.value, formMargin));
  };

  const onChange = (e) => {
    setReqType(e.target.value);
  };

  const onChangeDerivedCTC = (e) => {
    setCTCType(e.target.value);
  };

  const onChangeEducation = (value) => {
    console.log(value);
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const encodeJson = (values, action) => {
    let encodedJsonValues = {};

    console.log("data to encode", values);
    //FSM to maintain the JD state
    if (action == "NEW") {
      encodedJsonValues.jdstate = "Unassigned";
    }
    //get company details
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    encodedJsonValues.qhoid = userData.qhoid;
    encodedJsonValues.accounttype = userData.account_type;

    //now fill the parameters
    encodedJsonValues.jdproject = {};
    encodedJsonValues.jdproject.reqtype = reqType;
    encodedJsonValues.jdproject.buName = values.bu_name;
    encodedJsonValues.jdproject.projectName = values.proj_name;
    encodedJsonValues.jdproject.reqStatus = "Active";
    encodedJsonValues.jdproject.hmName = values.hm_name;
    encodedJsonValues.jdproject.hmEmail = values.hm_email;
    encodedJsonValues.jdproject.hmNumber = values.hm_number;
    encodedJsonValues.jdproject.NumPositions = parseInt(
      values.number_of_positions
    );
    encodedJsonValues.jdproject.minctc = parseFloat(values.min_ctc);
    if (ctcType === "normal") {
      encodedJsonValues.jdproject.maxctc = parseFloat(values.max_ctc);
    } else {
      encodedJsonValues.jdproject.maxctc = parseFloat(formMaxDerivedCTC) * 12;
    }
    encodedJsonValues.jdproject.ctctype = ctcType;
    encodedJsonValues.jdproject.finalbillrate = parseFloat(formFinalBillRate);
    encodedJsonValues.jdproject.margin = parseFloat(formMargin);
    encodedJsonValues.jdproject.maxctclpm = parseFloat(formMaxDerivedCTC);

    encodedJsonValues.jddetails = {};
    encodedJsonValues.jddetails.Title = values.title;
    encodedJsonValues.jddetails.JobPermission = values.job_permission; // private protected public
    encodedJsonValues.jddetails.JobTime = values.job_time; // full time, part time
    encodedJsonValues.jddetails.JobType = values.job_type; // permanent, contract
    encodedJsonValues.jddetails.JobCategory = values.job_category; // many types
    encodedJsonValues.jddetails.Designation = values.designation;
    encodedJsonValues.jddetails.Role = values.designation;

    encodedJsonValues.jdrequired = {};
    encodedJsonValues.jdrequired.Skills = values.skills;
    encodedJsonValues.jdrequired.RoleDetails = values.roles_and_responsibility;
    encodedJsonValues.jdrequired.Role = values.role;
    encodedJsonValues.jdrequired.RoleType = values.roletype;
    encodedJsonValues.jdrequired.Keywords = values.keywords;
    encodedJsonValues.jdrequired.Education = values.education;
    encodedJsonValues.jdrequired.NoticePeriod = parseInt(values.notice_period); //int
    encodedJsonValues.jdrequired.MinExperience = parseInt(values.min_exp);
    encodedJsonValues.jdrequired.MaxExperience = parseInt(values.max_exp);
    encodedJsonValues.jdrequired.WorkLocation = values.work_location;
    encodedJsonValues.jdrequired.Country = "India";
    encodedJsonValues.jdrequired.WorkMode = values.work_mode;
    encodedJsonValues.jdrequired.Diversity = false; //bool
    encodedJsonValues.jdrequired.Fresher = false; //bool
    encodedJsonValues.jdrequired.AdditionalInfo = "";

    //not assigned yet
    encodedJsonValues.jdassignment = null;

    encodedJsonValues.jduseraction = {};
    encodedJsonValues.jduseraction.isFavourite = false; //bool
    encodedJsonValues.jduseraction.colorCode = "";

    encodedJsonValues.jdclient = {};

    if (reqType === "customer_project") {
      encodedJsonValues.jdclient.ClientName = formClientName;
      encodedJsonValues.jdclient.TaName = formTaName;
      encodedJsonValues.jdclient.EndClient = values.end_client_name;
      encodedJsonValues.jdclient.ClientJobType = values.client_job_type;
    } else {
      encodedJsonValues.jdclient.clientName = "Internal";
      encodedJsonValues.jdclient.TaName = userData.username;
    }
    //not assinged yet
    //encodedJsonValues.jdclient.taName      ="";
    //encodedJsonValues.jdclient.taContact   ="";
    //encodedJsonValues.jdclient.taMail      ="";

    //encodedJsonValues.jdvendorconnect =[];
    //let vendorDetails ={}
    //vendorDetails.qhVID= "";
    //vendorDetails.vendorName ="";
    //encodedJsonValues.jdvendorconnect.push(vendorDetails);
    encodedJsonValues.jdother = {};
    encodedJsonValues.jdother.valid_until = values.valid_until;

    //get the current date
    let newDate = getTimeNow();
    encodedJsonValues.jdother.postingDate = newDate;
    encodedJsonValues.jdother.priority = values.priority;
    encodedJsonValues.jdother.postedby = userData.username;
    encodedJsonValues.jdother.qhuid = userData.qhuid;

    //no resume added
    encodedJsonValues.resumelist = null;
    return encodedJsonValues;
  };

  const handleFormSubmit = async (values) => {
    const jasonValues = encodeJson(values, "NEW");
    console.log("encoded Data", jasonValues);

    try {
      const jdID = await createJd({
        ...jasonValues,
      });
      message.success("New JD Created");
      navigate(`/jds/${jdID}`, { state: { newView: "assignment" } });
    } catch (err) {
      message.error("Failed to create JD. Please try again.");
      console.error("Error during JD creation:", err);
    }
  };

  const handleUpdateFormSubmit = (values) => {
    const jasonValues = encodeJson(values, "UPDATE");
    try {
      updateJd(
        {
          ...jasonValues,
        },
        value
      );
      message.success("JD Updated Successfully");
      navigate(`/jds/${value}`, { state: { newView: "assignment" } });

      setIsJDUpdated(true);
    } catch (err) {
      message.error("Failed to update JD. Please try again.");
      console.error("Error during JD creation:", err);
    }
  };

  return (
    <div className="qset-jd-creation-form-wrapper">
      {/* <div className="header">
        <LeftOutlined onClick={() => navigate("/qsethome/qsetjd")} />
      </div> */}
      <Form
        key={formKey}
        className="jd-creation-form"
        justify="start"
        layout="vertical"
        autoComplete="off"
        onFinish={value ? handleUpdateFormSubmit : handleFormSubmit}
        initialValues={jdValues}
      >
        <Form.Item
          required={true}
          className="jd-creation-field-item"
          label="Job Title"
          name="title"
        >
          <Input
            disabled={true}
            required={true}
            placeholder={"Enter the JD Title "}
            className="jd-creation-input"
          />
        </Form.Item>

        <div className="triple-input-wrapper">
          <Form.Item
            rules={[{ required: true, message: "Please select Job Type!" }]}
            className="jd-creation-field-item"
            label="Job Type"
            name="job_type"
          >
            <Select
              disabled={true}
              className="jd-creation-input"
              placeholder="Please Select"
              options={[
                { value: "Permanent", label: "Permanent" },
                { value: "Contract", label: "Contract" },
              ]}
            />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please select Job Time!" }]}
            name="job_time"
            className="jd-creation-field-item"
            label="Job Time"
          >
            <Select
              disabled={true}
              className="jd-creation-input"
              placeholder="Please Select"
              options={[
                { value: "Full Time", label: "Full Time" },
                { value: "Part Time", label: "Part Time" },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="number_of_positions"
            className="jd-creation-field-item"
            label="Number of Positions"
          >
            <Input disabled={true} type="text" className="jd-creation-input" />
          </Form.Item>
        </div>

        <div className="triple-input-wrapper">
          <Form.Item
            required={true}
            name="designation"
            className="jd-creation-field-item"
            label="Designation"
          >
            <Input
              disabled={true}
              required={true}
              className="jd-creation-input"
            />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please select role type!" }]}
            name="roletype"
            className="jd-creation-field-item"
            label="Role Type"
          >
            <Select
              disabled={true}
              required={true}
              className="jd-creation-input"
              options={ROLE_TYPE_OPTIONS}
            />
          </Form.Item>
          <Form.Item
            rules={[{ required: true, message: "Please select a role!" }]}
            name="role"
            className="jd-creation-field-item"
            label="Role"
          >
            <Select
              disabled={true}
              className="jd-creation-input"
              options={[
                { value: "Developer", label: "Developer" },
                { value: "Architect", label: "Architect" },
                { value: "Project Manager", label: "Project Manager" },
                { value: "Test and Verification", label: "Verification" },
                { value: "Integration", label: "Integrator" },
                { value: "SDET", label: "SDET" },
                { value: "QA", label: "QA" },
                { value: "Validation", label: "Validation" },
                { value: "Debugger", label: "Debugger" },
                { value: "Scrum Master", label: "Scrum Master" },
                { value: "Administrator", label: "Administrator " },
                { value: "Support", label: "Support" },
                { value: "Technical Writer", label: "Technical Writer" },
                { value: "Business Analyst", label: "Business Analyst" },
                { value: "Technical Support", label: "Technical Support" },
                { value: "Others", label: "Others" },
              ]}
            />
          </Form.Item>
        </div>

        <Form.Item
          required={true}
          name="roles_and_responsibility"
          className="jd-creation-field-item"
          label="Roles & Responsibility of the job"
        >
          <TextArea
            disabled={true}
            required={true}
            className="jd-creation-input-large"
          />
        </Form.Item>
        <Form.Item
          required={true}
          name="skills"
          className="jd-creation-field-item"
          label="Required skills "
        >
          <TextArea
            disabled={true}
            required={true}
            className="jd-creation-input-large"
          />
        </Form.Item>

        <div className="triple-input-wrapper">
          <Form.Item
            className="jd-creation-field-item"
            label="Experience Range (Yrs) "
            required={true}
          >
            <Space style={{ display: "flex", gap: "8px" }}>
              <Form.Item
                required={true}
                className="jd-creation-field-item"
                name="min_exp"
              >
                <Input
                  disabled={true}
                  type="number"
                  required={true}
                  className="jd-creation-input"
                  placeholder="Min"
                />
              </Form.Item>
              <Form.Item
                required={true}
                className="jd-creation-field-item"
                name="max_exp"
              >
                <Input
                  disabled={true}
                  type="number"
                  required={true}
                  className="jd-creation-input"
                  placeholder="Max"
                />
              </Form.Item>
            </Space>
          </Form.Item>
          <Form.Item
            className="jd-creation-field-item"
            label="Offered CTC (LPA)"
            required={true}
          >
            <Space>
              <Form.Item name="min_ctc" className="jd-creation-field-item">
                <Input
                  disabled={true}
                  type="number"
                  required={true}
                  className="jd-creation-input"
                  placeholder="Min"
                />
              </Form.Item>
              {ctcType === "normal" ? (
                <>
                  <Form.Item
                    required={true}
                    name="max_ctc"
                    className="jd-creation-field-item"
                  >
                    <Input
                      disabled={true}
                      type="number"
                      required={true}
                      className="jd-creation-input"
                      placeholder="Max"
                    />
                  </Form.Item>
                </>
              ) : (
                <>
                  <Form.Item required={true} className="jd-creation-field-item">
                    <Input
                      disabled={true}
                      required={true}
                      className="jd-creation-input"
                      value={formMaxDerivedCTC * 12}
                    />
                  </Form.Item>
                </>
              )}
            </Space>
          </Form.Item>
          <Form.Item
            required={true}
            className="jd-creation-field-item"
            label="Notice Period (Days)"
            name="notice_period"
          >
            <Input
              disabled={true}
              type="number"
              required={true}
              className="jd-creation-input"
            />
          </Form.Item>
        </div>

        <div className="triple-input-wrapper">
          <Form.Item
            required={true}
            name="education"
            className="jd-creation-field-item"
            label="Education"
          >
            <Cascader
              disabled={true}
              required={true}
              className="jd-creation-input"
              options={educationList}
              onChange={onChangeEducation}
              placeholder="Please Select"
              multiple
            />
          </Form.Item>

          <Form.Item
            rules={[
              { required: true, message: "Please select Work Location!" },
            ]}
            name="work_location"
            className="jd-creation-field-item"
            label="Work Location"
          >
            <Select
              disabled={true}
              placeholder="Please Select"
              className="jd-creation-input"
              mode="multiple"
              allowClear
              options={SUPPORTED_LOCATION}
            />
          </Form.Item>

          <Form.Item
            rules={[
              { required: true, message: "Please select Job Permission!" },
            ]}
            name="work_mode"
            className="jd-creation-field-item"
            label="Work Mode"
          >
            <Select
              disabled={true}
              className="jd-creation-input"
              placeholder="Please Select"
              options={WORK_OPTIONS}
            />
          </Form.Item>
        </div>
      </Form>
    </div>
  );
}

export default QSETJdDetails;
